import { makeStyles } from '@material-ui/core';
import { useEffect, useState } from 'react';
import { planEatApi } from '../../../planEatApi/PlanEatApi';
import { IBookingContent, IDishContent, ISeatingContent, IVersionedObject } from '../../../planEatApi/PlanEatFacade';
import { UpcomingBookings } from '../components/UpcomingBookings';
import { WeekPicker } from '../../../components/ui/WeekPicker';
import { useQuery } from '../../../hooks/useQuery';
import { DATE_QUERY_PARAM } from '../../../constants/constants';
import { simpleDate } from '../../../config/dateFormatting';
import { useHistory } from 'react-router-dom';
import { useAdminDateQueryParam } from '../../../hooks/useAdminDateQueryParam';

const useStyles = makeStyles((theme: any) => ({
    dashboardTopOverviewRow: {
        display: 'grid',
        columnGap: 30
    },
    dashboardOverviewContainer: {
        width: '100%',
        background: '#FFFFFF',
        boxShadow: '0px 4px 4px rgba(11, 37, 89, 0.1)',
        borderRadius: 8,
        padding: 30,
    },
    todaysDateHeader: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
}));

export const AdminUpcoming: React.FC = () => {
    // Styling
    const classes = useStyles();
    
    // State
    const [weekDates, setWeekDates] = useState<Date[]>([]);
    const [weekNumberString, setWeekNumberString] = useState('');
    const [date, setDate] = useState<Date>(new Date);
    const [menuView, setMenuView] = useState<any[]>([]);

    // Entities
    const [seatings,setSeatings] = useState<IVersionedObject<ISeatingContent>[]>();
    const [bookings,setBookings] = useState<IVersionedObject<IBookingContent>[]>();
    const [dishes,setDishes] = useState<IVersionedObject<IDishContent>[]>();

    /*Get required info */
    async function getDatabase(){
        await planEatApi.getSeatings().then((response) => {setSeatings(response.data)}).catch((e) => {console.log(e)})
        await planEatApi.getBookings().then((response) => {setBookings(response.data)}).catch((e) => {console.log(e)})
        await planEatApi.getDishes().then((response) => {setDishes(response.data)}).catch((e) => {console.log(e)})
    }

    useEffect(() => {
        getDatabase()
    }, []);

    /* Update local date if global different than today */
    useAdminDateQueryParam(date,setDate)

    useEffect(() => {
        displayMenus();  
    }, [seatings, bookings, dishes, weekDates]);

    function displayMenus() {
        var tmpMenus: any[] = [];
        if(seatings && bookings && dishes){
            weekDates.map((date, index) => {
                tmpMenus.push(
                    <UpcomingBookings seatings={seatings} bookings={bookings} dishes={dishes} key={index} date={date}></UpcomingBookings>
                )
            })
            setMenuView(tmpMenus);
        }
    }

    return (
        <div>
            <div>
                <WeekPicker date={date} setDate={setDate} setWeekDates={setWeekDates} canCalendarPick={true}/>
            </div>
            <div className={classes.todaysDateHeader}>
                {weekNumberString}
            </div>

            <div className={classes.dashboardTopOverviewRow} >
                <div className={classes.dashboardOverviewContainer}>
                    {menuView}
                </div>
            </div>
        </div>
    );
}